import { FETCH_FICHAS_ENTREGA_DESCARGAR } from '../actions';

export default function(state = null, action) {
  switch (action.type) {
    case FETCH_FICHAS_ENTREGA_DESCARGAR:
      if (action.payload.data.estadoTrama === '1') {
        return action.payload.data;
      }
      return null;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/FichasEntregaDescarga.js